/**
 * Each Extend adds three days. Matches `PREVIEW_EXTEND_DAYS` in
 * `packages/agents/src/previews.ts`. The web bundle does not import that
 * package.
 */
export const PREVIEW_EXTEND_MINUTES = 3 * 24 * 60;
export const PREVIEW_EXTEND_LABEL = "Extend 3 days";
